import { ComponentProps } from "react";
import { NavbarContentCenter } from "./components/NavbarContentCenter";
import { NavbarContentLeft } from "./components/NavbarContentLeft";
import { NavbarContentRight } from "./components/NavbarContentRight";
import { NavbarItem } from "./components/NavbarItem";
import { NavbarLogo } from "./components/NavbarLogo/NavbarLogo";
import { NavbarSeparator } from "./components/NavbarSeparator/NavbarSeparator";
import clsx from "clsx";

export function Navbar({ children, className, ...rest }: ComponentProps<"div">) {
  return (
    <div
      id="navbar"
      className={clsx(
        "relative flex flex-row w-full bg-white text-text-base-primary",
        "h-(--navbar-mobile-height) md:h-(--navbar-height)",
        "bg-white",
        className
      )}
      {...rest}
    >
      {children}
      <div className="absolute bottom-0 left-0 right-0 border-b border-b-blue-grey-300" />
    </div>
  );
}

Navbar.Wrapper = Navbar;
Navbar.Left = NavbarContentLeft;
Navbar.Center = NavbarContentCenter;
Navbar.Right = NavbarContentRight;
Navbar.Logo = NavbarLogo;
Navbar.Separator = NavbarSeparator;
Navbar.Item = NavbarItem;
